'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_SealedTrait$SubtypeValue(subtype, v) {
  this.wc = null;
  this.wc = subtype;
}
export { $c_Lmagnolia1_SealedTrait$SubtypeValue as $c_Lmagnolia1_SealedTrait$SubtypeValue };
$p = $c_Lmagnolia1_SealedTrait$SubtypeValue.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_SealedTrait$SubtypeValue;
/** @constructor */
function $h_Lmagnolia1_SealedTrait$SubtypeValue() {
}
export { $h_Lmagnolia1_SealedTrait$SubtypeValue as $h_Lmagnolia1_SealedTrait$SubtypeValue };
$h_Lmagnolia1_SealedTrait$SubtypeValue.prototype = $p;
var $d_Lmagnolia1_SealedTrait$SubtypeValue = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_SealedTrait$SubtypeValue, "magnolia1.SealedTrait$SubtypeValue", ({
  nU: 1
}));
export { $d_Lmagnolia1_SealedTrait$SubtypeValue as $d_Lmagnolia1_SealedTrait$SubtypeValue };
